/**
 * The institution-profiles index's `sector` values are institution types (AU: the ACIR
 * organisation types; US: the pipeline's own labels, "University", "Community College" and
 * "Military"). The ones with a student-facing name are listed here with the i18n key that names
 * them and the order the directory's type chip offers them in; any other value is shown as the
 * index spells it, after them. Each cluster's index carries only its own country's values, so
 * the two sets share the order slots.
 */
const INSTITUTION_TYPES: Record<string, { key: string; order: number }> = {
  'University/Higher Education Institution': { key: 'university', order: 0 },
  'TAFE Institute': { key: 'tafe', order: 1 },
  'Higher Education Institutions': { key: 'higherEducationProvider', order: 2 },
  'Registered Training Organisation': { key: 'registeredTrainingOrganisation', order: 3 },
  'University': { key: 'university', order: 0 },
  'Community College': { key: 'communityCollege', order: 1 },
};

/** The i18n key under `unified.institutionGuide.institutionType` that names a sector value, or null for one the map does not know. */
export const institutionTypeI18nKey = (sector: string | null | undefined): string | null =>
  (sector && INSTITUTION_TYPES[sector] ? `unified.institutionGuide.institutionType.${INSTITUTION_TYPES[sector].key}` : null);

/** Where a type sits in the chip: the named types in their order, then the rest as the config lists them. */
export const institutionTypeOrder = (sector: string): number => INSTITUTION_TYPES[sector]?.order ?? Number.MAX_SAFE_INTEGER;

/** The types a student would recognise by name first (AU: universities and TAFEs; US: universities and community colleges), for a short showcase list. */
export const isLeadInstitutionType = (sector: string): boolean => institutionTypeOrder(sector) <= 1;
